export default __webpack_public_path__ + "static/media/Background_00210.0954549d.png";